import { render, staticRenderFns } from "./appidPup.vue?vue&type=template&id=2f48d32e&scoped=true&"
import script from "./appidPup.vue?vue&type=script&lang=js&"
export * from "./appidPup.vue?vue&type=script&lang=js&"
import style0 from "./appidPup.vue?vue&type=style&index=0&id=2f48d32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48d32e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f48d32e')) {
      api.createRecord('2f48d32e', component.options)
    } else {
      api.reload('2f48d32e', component.options)
    }
    module.hot.accept("./appidPup.vue?vue&type=template&id=2f48d32e&scoped=true&", function () {
      api.rerender('2f48d32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/roles/components/appidPup.vue"
export default component.exports